/*
 * hp-announce — window.hpAnnounce(message, options)
 *
 * THE way anything in this theme speaks to assistive technology. The regions
 * themselves are snippets/hp-announcer.liquid; read that file first, it holds
 * why there are two of them and why `.ignore-empty` is load-bearing.
 *
 *     hpAnnounce('24 products');                       // polite (default)
 *     hpAnnounce('Could not update cart', { assertive: true });
 *
 * ── CALL SITES DO NOT GUARD, AND DO NOT NEED TO ─────────────────────────────
 * Same contract as `hpTrack` (snippets/hp-analytics.liquid): the function is
 * always defined, always safe to call, and an unconfigured or broken state is
 * silent rather than throwing into whatever component called it. An
 * announcement is a nicety; a TypeError in a variant-change handler is a
 * broken product page.
 *
 * This file is loaded FIRST among the theme's deferred scripts in
 * layout/theme.liquid, and deferred scripts execute in document order, so
 * `hpAnnounce` exists before any other deferred script runs — including the
 * ones a section loads from the body. The one case that would still be early
 * is an INLINE script announcing during parse, which cannot happen
 * meaningfully: there is nothing to announce before the visitor has acted.
 *
 * ── THE PART THAT IS EASY TO GET WRONG: A REGION DOES NOT RE-ANNOUNCE ───────
 * Writing the same string into a live region a second time is not a change, so
 * nothing is spoken. Filtering twice to the same count, or nudging quantity up
 * and back down, both produce identical text and the second one is silent.
 *
 * The region is therefore CLEARED first and the message written on a later
 * task, so the region always travels '' -> text and every announcement is a
 * real mutation regardless of what it said last time. The delay is also what
 * makes coalescing possible below.
 *
 * ── RAPID CHANGES COALESCE TO THE LAST ONE ──────────────────────────────────
 * Clicking through four swatches must not queue four announcements that read
 * out long after the shopper has stopped. Each politeness keeps ONE pending
 * timer and a later call replaces the earlier one, so what is spoken is the
 * state the visitor actually landed on. This is the same reasoning as the
 * cart's busy state hanging on the interaction rather than the request.
 */
(function () {
  'use strict';

  var REGIONS = { polite: 'HpAnnouncerPolite', assertive: 'HpAnnouncerAssertive' };

  /* Long enough that the clear and the write land in separate tasks, short
     enough to feel simultaneous with the interaction that caused it. */
  var WRITE_DELAY = 60;

  /* A guard, not a design: assistive technology reads the whole region, so a
     runaway string (a rogue innerText, a concatenation bug) would be read out
     in full with no way to stop it. */
  var MAX_LENGTH = 300;

  var pending = { polite: null, assertive: null };

  function announce(message, options) {
    try {
      var text = message == null ? '' : String(message);

      /* Messages are routinely built from textContent read back out of the
         DOM, which carries the markup's own newlines and indentation. */
      text = text.replace(/\s+/g, ' ').trim();
      if (!text) return;
      if (text.length > MAX_LENGTH) text = text.slice(0, MAX_LENGTH);

      var key = options && options.assertive ? 'assertive' : 'polite';
      var region = document.getElementById(REGIONS[key]);
      if (!region) return;

      clearTimeout(pending[key]);
      region.textContent = '';

      pending[key] = setTimeout(function () {
        region.textContent = text;
      }, WRITE_DELAY);
    } catch (e) {
      /* Never throw at a call site. */
    }
  }

  window.hpAnnounce = announce;
})();
